import store from "@/js/store/index";

export function getTimeZoneName() {
	const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	return timeZone ? (timeZone === "Europe/Kyiv" ? "Europe/Kiev" : timeZone) : "Etc/UTC";
}

export function getCurrentTimezone() {
	const cu = store.getters.currentUser;
	return cu && cu.zone ? cu.zone : "Etc/UTC";
}

export function correctDate(date = Date.now(), zone = getCurrentTimezone()) {
	const d = new Date(date);
	return new Date(d.toLocaleString("en-US", { timeZone: zone }));
}

export function dd_mm_yyyy(millis) {
	const date = correctDate(millis);
	const dateNum = numberZeroPrettier(date.getDate());
	const month = numberZeroPrettier(date.getMonth() + 1);
	const year = date.getFullYear();
	return `${dateNum}.${month}.${year}`;
}

export function www_mmm_dd_yyyy(millis) {
	return correctDate(millis).toDateString();
}

export function d_mmmm(millis) {
	const date = correctDate(millis);
	const dateNum = date.getDate();
	const month = date.toLocaleString("en-US", { month: "long" });
	return `${dateNum} ${month}`;
}

export function mmm_dd(millis) {
	const date = correctDate(millis);
	const month = date.toLocaleString("en-US", { month: "short" });
	const dateNum = date.getDate();
	return `${month} ${dateNum}`;
}

export function mmm_dd_yyyy(millis) {
	const date = correctDate(millis);
	const year = date.getFullYear();
	return `${mmm_dd(millis)}, ${year}`;
}

export function mmm_dd_yy(millis) {
	const date = correctDate(millis);
	const year = date.getFullYear().toString().substring(2);
	return `${mmm_dd(millis)}, ${year}`;
}

export function hh_mm(millis) {
	const date = correctDate(millis);
	const hours = numberZeroPrettier(date.getHours());
	const minutes = numberZeroPrettier(date.getMinutes());
	return `${hours}:${minutes}`;
}

export function hh_mm_apm(millis) {
	const date = correctDate(millis);
	const hours = date.getHours();
	const hoursIn12Format = convertTime24to12(hours);
	const minutes = numberZeroPrettier(date.getMinutes());
	const amp = amOrPm(hours);
	return `${hoursIn12Format}:${minutes} ${amp}`;
}

export function yyyy(millis) {
	return correctDate(millis).getFullYear();
}

export function numberZeroPrettier(num, withPlus) {
	let res = "";
	if (Math.abs(parseInt(num)) < 10) {
		res = num < 0 ? `-0${Math.abs(num)}` : `0${num}`;
	} else {
		res = num.toString();
	}
	return withPlus && num >= 0 ? "+" + res : res;
}

export function convertTime24to12(time) {
	return numberZeroPrettier(time % 12 || 12);
}

export function amOrPm(hours) {
	return hours >= 12 ? "pm" : "am";
}

export function getOffset(timeZone = getCurrentTimezone(), date = new Date()) {
	const utcDate = new Date(date.toLocaleString("en-US", { timeZone: "UTC" }));
	const tzDate = new Date(date.toLocaleString("en-US", { timeZone }));
	return (tzDate.getTime() - utcDate.getTime()) / 6e4;
}

export function toHoursAndMinutes(totalMinutes = getOffset()) {
	let hours = Math.floor(Math.abs(totalMinutes) / 60);
	const minutes = totalMinutes % 60;
	const formattedMinutes = minutes === 0 ? "00" : Math.abs(minutes);
	if (totalMinutes < 0) hours = hours * -1;
	return numberZeroPrettier(hours, true) + ":" + formattedMinutes;
}

export function XXh_XXmin(ms) {
	const totalMinutes = Math.floor(ms / 60000);
	const hours = Math.floor(totalMinutes / 60);
	const minutes = totalMinutes % 60;
	return `${hours}h ${minutes}min`;
}

export function isToday(someDate) {
	const today = new Date();
	const correctSomeDate = new Date(someDate);

	return (
		correctSomeDate.getFullYear() === today.getFullYear() &&
		correctSomeDate.getMonth() === today.getMonth() &&
		correctSomeDate.getDate() === today.getDate()
	);
}
export function isYesterday(someDate) {
	const today = new Date();
	const correctSomeDate = new Date(someDate);

	const yesterday = new Date(today);
	yesterday.setDate(yesterday.getDate() - 1);

	return (
		correctSomeDate.getFullYear() === yesterday.getFullYear() &&
		correctSomeDate.getMonth() === yesterday.getMonth() &&
		correctSomeDate.getDate() === yesterday.getDate()
	);
}

export function timeAgo(dateString, strict = true) {
	const date = new Date(dateString);
	const now = new Date();
	const diffInMs = now - date;
	const diffInMinutes = diffMinutes(date, now);
	const diffInHours = diffHours(date, now);
	const diffInDays = diffDates(date, now);
	const diffInMonths = diffMonths(date, now);
	const diffInYears = diffYears(date, now);

	if (diffInMs < 60 * 1000) {
		return "Just now";
	} else if (diffInMinutes < 60) {
		if (strict) {
			return `${diffInMinutes} minute${diffInMinutes !== 1 ? "s" : ""} ago`;
		} else {
			return "Less than an hour ago";
		}
	} else if (diffInHours < 24) {
		return `${diffInHours} hour${diffInHours !== 1 ? "s" : ""} ago`;
	} else if (diffInDays < 30) {
		return `${diffInDays} day${diffInDays !== 1 ? "s" : ""} ago`;
	} else if (diffInMonths < 12) {
		return `${diffInMonths} month${diffInMonths !== 1 ? "s" : ""} ago`;
	} else {
		return `${diffInYears} year${diffInYears !== 1 ? "s" : ""} ago`;
	}
}

export function diffYears(dayOne, dayTwo) {
	const yearOne = dayOne.getFullYear();
	const yearTwo = dayTwo.getFullYear();
	const monthOne = dayOne.getMonth();
	const monthTwo = dayTwo.getMonth();

	let yearDiff = yearTwo - yearOne;

	if (monthTwo < monthOne || (monthTwo === monthOne && dayTwo.getDate() < dayOne.getDate())) {
		yearDiff--;
	}

	return yearDiff;
}

export function diffMonths(dayOne, dayTwo) {
	const yearOne = dayOne.getFullYear();
	const yearTwo = dayTwo.getFullYear();
	const monthOne = dayOne.getMonth();
	const monthTwo = dayTwo.getMonth();

	return (yearTwo - yearOne) * 12 + (monthTwo - monthOne);
}

export function diffDates(dayOne, dayTwo) {
	return Math.round(Math.abs(dayOne - dayTwo) / (60 * 60 * 24 * 1000));
}

export function diffHours(dayOne, dayTwo) {
	return Math.round(Math.abs(dayOne - dayTwo) / (60 * 60 * 1000));
}

export function diffMinutes(dayOne, dayTwo) {
	return Math.round(Math.abs(dayOne - dayTwo) / (60 * 1000));
}
